import React, { useState, useEffect, useMemo } from 'react';
import { Button, Col, Input, Row, Label, ModalBody, Form, Spinner, Alert } from 'reactstrap';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { getDataSpedNormative } from '../../../../slices/thunks';
import OHr from '../../../../Components/OElements/OHr';
import SimpleBar from 'simplebar-react';
import OPlaceholder from '../../../../Components/OElements/OPlaceholder';
import { addNewArticle } from '../../../../slices/article/thunk';

const BCNForm = ({ bcn_code, normative_id, handleToggleModalBCN }) => {
    const dispatch = useDispatch();
    const [updating, setUpdating] = useState(false);

    const selectorBCN = createSelector(
        state => state.DataSped,
        dataList => ({
            dataList: dataList.itemDataSpedList,
            isLoadingList: dataList.isLoadingList
        })
    );

    const { dataList, isLoadingList } = useSelector(selectorBCN);

    useEffect(() => {
        if (bcn_code) {
            dispatch(getDataSpedNormative(bcn_code));
        }
    }, [bcn_code, dispatch]);


    // const processContent = (content) => {
    //     // Verificar que el contenido no sea nulo o indefinido
    //     if (!content || typeof content !== 'string') {
    //         return null;  // Si no hay contenido válido, no retorna nada
    //     }

    //     return content.split('\n\n').map((paragraph, index) => {
    //         // Reemplazamos '\n' simple por un espacio en las frases.
    //         paragraph = paragraph.replace(/\n/g, ' ');

    //         // Detectar si el párrafo comienza con una numeración (e.g., "f)", "1)")
    //         const isPrimaryList = /^\s*[a-z]\)/.test(paragraph);  // Nivel principal de la lista, e.g. "a)"
    //         const isSecondaryList = /^\s*\d+\)/.test(paragraph);   // Subnivel numérico, e.g. "1)"
    //         const isTertiaryList = /^\s*\d+\.\d+/.test(paragraph); // Tercer nivel, e.g. "1.1"

    //         // Aplicar indentación o estilos diferentes dependiendo del nivel de lista
    //         if (isPrimaryList) {
    //             return <p key={index} style={{ marginLeft: '20px' }}>{paragraph.trim()}</p>;
    //         } else if (isSecondaryList) {
    //             return <p key={index} style={{ marginLeft: '40px' }}>{paragraph.trim()}</p>;
    //         } else if (isTertiaryList) {
    //             return <p key={index} style={{ marginLeft: '60px', fontStyle: 'italic' }}>{paragraph.trim()}</p>;
    //         } else {
    //             return <p key={index}>{paragraph.trim()}</p>;  // Sin lista
    //         }
    //     });
    // };



    const processContent = (content) => {
        // Verificar que el contenido no sea nulo o indefinido
        if (!content || typeof content !== 'string') {
            return null;  // Si no hay contenido válido, no retorna nada
        }

        // Eliminar saltos de línea excesivos y espacios al principio de las líneas
        content = content.replace(/\s*\n\s*/g, ' ').trim();

        // Verificar si el contenido ya no necesita más procesamiento y retornarlo como un párrafo
        return <p>{content}</p>;
    };


    const formatText = (text) => {
        if (!text) return ''; // Si no hay texto, retorna cadena vacía
        // Eliminar espacios innecesarios y múltiples saltos de línea, uniendo en un solo espacio
        return text.replace(/\s*\n\s*/g, ' ').replace(/\s\s+/g, ' ').trim();
    };
    
    const processHierarchy = (dataList) => {
        const result = [];
    
        dataList.estructuras_funcionales?.estructura_funcional?.forEach((func) => {
            // Primer nivel
            const titleContent = formatText(func.texto?.content[0]);
    
            if (func.estructuras_funcionales?.estructura_funcional?.length > 0) {
                func.estructuras_funcionales.estructura_funcional.forEach((subFunc) => {
                    // Segundo nivel
                    const subFuncContent = formatText(subFunc.texto?.content[0]);
    
                    if (subFunc.estructuras_funcionales?.estructura_funcional?.length > 0) {
                        subFunc.estructuras_funcionales.estructura_funcional.forEach((thirdFunc) => {
                            // Tercer nivel
                            const thirdFuncContent = formatText(thirdFunc.texto?.content[0]);
    
                            if (thirdFunc.estructuras_funcionales?.estructura_funcional?.length > 0) {
                                thirdFunc.estructuras_funcionales.estructura_funcional.forEach((fourthFunc) => {
                                    // Cuarto nivel
                                    const fourthFuncContent = formatText(fourthFunc.texto?.content[0]);
                                    result.push({
                                        title: titleContent,
                                        paragraph: subFuncContent,
                                        article: thirdFuncContent,
                                        subArticle: fourthFuncContent,
                                        normative_id: normative_id,  // Agregamos el normative_id aquí
                                    });
                                });
                            } else {
                                // Solo tres niveles
                                result.push({
                                    title: titleContent,
                                    paragraph: subFuncContent,
                                    article: thirdFuncContent,
                                    normative_id: normative_id,  // Agregamos el normative_id aquí
                                });
                            }
                        });
                    } else {
                        // Solo dos niveles
                        result.push({
                            title: titleContent,
                            article: subFuncContent,
                            normative_id: normative_id,  // Agregamos el normative_id aquí
                        });
                    }
                });
            } else {
                // Solo un nivel
                result.push({
                    article: titleContent,
                    normative_id: normative_id,  // Agregamos el normative_id aquí
                });
            }
        });
    
        return result;
    };

    // Uso dentro de Formik onSubmit
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            // Tus valores iniciales
        },
        validationSchema: Yup.object({
            // Tu esquema de validación
        }),
        onSubmit: async (values) => {
            setUpdating(true)
            const processedHierarchy = processHierarchy(dataList);
            
            processedHierarchy.forEach((item) => {
                console.log(item)
                dispatch(addNewArticle(item));
            });

            console.log('Processed Hierarchy with normative_id:', processedHierarchy);
            setUpdating(false)
        },
    });







    return (
        <React.Fragment>
            <Form
                className='tablelist-form'
                onSubmit={e => {
                    e.preventDefault();
                    validation.handleSubmit();
                }}
            >
                <ModalBody>
                    {isLoadingList ? <OPlaceholder /> : (
                        <Row>
                            <Col lg={6}>
                                <OHr text={'Identificador'} />
                                <p className='m-0'><strong>Tipo:</strong> {dataList.identificador?.tipos_numeros?.tipo_numero[0]?.tipo}</p>
                                <p className='m-0'><strong>Número:</strong> {dataList.identificador?.tipos_numeros?.tipo_numero[0]?.numero}</p>
                                <p className='m-0'><strong>Organismos:</strong> {dataList.identificador?.organismos?.organismo.join(', ')}</p>
                                <p className='m-0'><strong>Fecha Publicación:</strong> {dataList.identificador?.fecha_publicacion}</p>
                                <p className='m-0'><strong>Fecha Promulgación:</strong> {dataList.identificador?.fecha_promulgacion}</p>
                            </Col>

                            <Col lg={6}>
                                <OHr text={'Metadatos'} />
                                <p className='m-0'><strong>Título Norma:</strong> {dataList.metadatos?.titulo_norma || 'No disponible'}</p>
                                <p className='m-0'><strong>Identificación Fuente:</strong> {dataList.metadatos?.identificacion_fuente}</p>
                                <p className='m-0'><strong>Número Fuente:</strong> {dataList.metadatos?.numero_fuente}</p>
                            </Col>

                            <Col>
                                <OHr text={'Cuerpo'} />
                                <SimpleBar style={{ maxHeight: "300px" }}>
                                    {dataList.estructuras_funcionales?.estructura_funcional.map((func, index) => (
                                        <div key={index} style={{ marginBottom: '10px' }}>
                                            <Row>
                                                <Col lg={12}>
                                                    {processContent(func.texto?.content[0] || '')}
                                                </Col>
                                            </Row>

                                            {/* Si hay estructuras funcionales de segundo nivel */}
                                            {func.estructuras_funcionales?.estructura_funcional?.map((subFunc, index2) => (
                                                <div key={index2} style={{ paddingLeft: '20px', marginBottom: '10px' }}>
                                                    <Row>
                                                        <Col lg={12}>
                                                            {processContent(subFunc.texto?.content[0] || '')}
                                                        </Col>
                                                    </Row>

                                                    {/* Si hay estructuras funcionales de tercer nivel */}
                                                    {subFunc.estructuras_funcionales?.estructura_funcional?.map((thirdFunc, index3) => (
                                                        <div key={index3} style={{ paddingLeft: '40px', marginBottom: '10px' }}>
                                                            <Row>
                                                                <Col lg={12}>
                                                                    {processContent(thirdFunc.texto?.content[0] || '')}
                                                                </Col>
                                                                {thirdFunc.texto?.content[1]?.tipo_contenido === "image/jpeg" && (
                                                                    <Col lg={12}>
                                                                        <img
                                                                            src={`data:image/jpeg;base64,${thirdFunc.texto?.content[1]?.data_codificada}`}
                                                                            alt={thirdFunc.texto?.content[1]?.nombre || "Imagen"}
                                                                            style={{ maxWidth: '100%', height: 'auto' }}
                                                                        />
                                                                    </Col>
                                                                )}
                                                            </Row>
                                                        </div>
                                                    ))}

                                                </div>
                                            ))}
                                        </div>
                                    ))}
                                </SimpleBar>



                            </Col>
                        </Row>
                    )}

                </ModalBody>

                <div className='modal-footer'>
                    <div className='hstack gap-2 justify-content-end'>
                        <Button
                            type='button'
                            onClick={() => {
                                handleToggleModalBCN();
                            }} className='btn-danger btn-label'>
                            <i className="icon-x label-icon"></i>
                            Cancelar
                        </Button>
                        <button
                            type='submit'
                            className='btn btn-label btn-primary'
                            id='add-btn'
                            disabled={updating}
                        >
                            {updating ? (
                                <i className="label-icon"><Spinner size='sm' /></i>
                            ) : <i className={`${Icons.refresh} label-icon`}></i>}
                            Sincronizar
                        </button>
                    </div>
                </div>
            </Form>
        </React.Fragment>
    );
};

export default BCNForm;
